import React, { createContext, useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "../assets/styles/themes";
import { GlobalStyle } from "../assets/styles/GlobalStyle";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const storedTheme = localStorage.getItem("isDarkMode");
  const initialIsDarkMode = storedTheme !== null 
    ? JSON.parse(storedTheme) 
    : window.matchMedia("(prefers-color-scheme: dark)").matches;

  const [isDarkMode, setIsDarkMode] = useState(initialIsDarkMode);

  const toggleTheme = () => {
    setIsDarkMode((prev) => {
      const newValue = !prev;
      localStorage.setItem("isDarkMode", JSON.stringify(newValue));
      return newValue;
    });
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleChange = () => {
      const systemIsDarkMode = mediaQuery.matches;
      setIsDarkMode((prev) => {
        if (systemIsDarkMode !== prev) {
          localStorage.setItem("isDarkMode", JSON.stringify(systemIsDarkMode));
          return systemIsDarkMode;
        }
        return prev;
      });
    };

    handleChange();
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const theme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};